import "./InfoPanel.css";
import React from "react";
import infoData from "./data/promptHelp.json";
import { useDispatch, useSelector } from "react-redux";
import { getARMode, getPromptMode, setPromptMode, setPromptShowcase } from "../redux_store/appState";
import { PROMPT_PAN, PROMPT_ROTATE, PROMPT_ZOOM } from "./Viewer";
import { APP_DEBUG } from "../AppConfig";

/**
 * Generates the panel used to display interaction prompt messages.
 * @returns <main> panel containing interaction prompt messages.
 */
export function InfoPanel() {
    const dispatch = useDispatch();

    // Current state
    const arMode = useSelector(getARMode);
    const promptMode = useSelector(getPromptMode);

    /**
     * Triggers the auto-scrolling showcase to stop when the user selects a prompt mode.
     * @param {object} event onchange event.
     */
    const onChange = (event) => {
        if (event.target.checked) {
            dispatch(setPromptMode(Number(event.target.id.slice(-1))));
            dispatch(setPromptShowcase(false));
        }
    };

    /**
     * Generates a <section> containing each prompt mode info blurb.
     * @returns Prompt mode info blurbs
     */
    const infoBlurbs = () => {
        if (arMode) {
            return infoData[arMode].map((blurb, i) => {
                return (
                    <section id={`content${i}`} key={i}>
                        <p>{blurb}</p>
                    </section>
                );
            });
        }

        return <p>{infoData.no_ar}</p>;
    };

    /**
     * Generates the radio button for the prompt mode that backs the tab selections.
     * @param {number} mode Prompt mode.
     * @returns Prompt mode input.
     */
    const actionInput = (mode) => {
        if (arMode) {
            return (
                <input id={`tab${mode}`} type="radio" name="tabs" checked={promptMode === mode} onChange={onChange} />
            );
        }
    };

    /**
     * Generates the label for the prompt mode that is used as a tab selection for the user.
     * @param {number} mode Prompt mode.
     * @param {string} label Title for the tab selection.
     * @returns Prompt mode label.
     */
    const actionLabel = (mode, label) => {
        if (arMode) {
            return <label htmlFor={`tab${mode}`}>{label}</label>;
        }
    };

    return (
        <div>
            {/* <h3>AR Mode Instructions:</h3>
            {arMode ? <p>{infoData.enter_ar}</p> : ""}
            <main>
                {actionInput(PROMPT_ROTATE)}
                {actionLabel(PROMPT_ROTATE, "Rotating")}
                {actionInput(PROMPT_ZOOM)}
                {actionLabel(PROMPT_ZOOM, "Resizing")}
                {actionInput(PROMPT_PAN)}
                {actionLabel(PROMPT_PAN, "Moving")}
                {infoBlurbs()}
            </main>
            {APP_DEBUG ? <p style={{ fontSize: "10px" }}>Debug: AR Mode = {arMode}</p> : ""} */}
        </div>
    );
}
